import React from "react";
import PropTypes from "prop-types";

const CarouselCard = (props) => {
  return (
    <div className="PostCarousel-card Card bg-white external-icons">
      <div className="Card-inner c-white">
        {props.images && (
          <div className="PostCarousel-image bg-image">
            <img
              className={`bg-image-source ${props.images["type"]}`}
              src={`${props.images["default"]}`}
              srcSet={
                props.images["type"] === "provided"
                  ? `${props.images["xsmall"]} 322w, ${props.images["small"]} 640w, ${props.images["medium"]} 960w`
                  : null
              }
              alt=""
            />
          </div>
        )}
        <div className="Card-inner-contentWrapper">
          <div className="Card-inner-content">
            <a className="PostCarousel-card-link f-h4" href={props.link}>
              {props.title}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

CarouselCard.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default CarouselCard;
